import styled from "styled-components";

export const Container = styled.div`
  margin-top: ${({ m }) => (m ? "100px" : "0px")};

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.color.secondary};
    &:hover {
      text-decoration: underline;
    }
  }
  #liveSession {
    tr > :first-child {
      text-align: right;
    }
    tr > :last-child {
      text-align: left;
    }
  }

  ul {
    margin: 0;
  }
`;
